import {cloneDeep} from "lodash"
import {BasketTotalWithBreakDown, BasketItem} from "@irati/types"
import totals, {TotalsData} from "./totals"

const fullPercentage = 100

export default function totalsCashback(items: BasketItem[], data: TotalsData, rate: number): BasketTotalWithBreakDown {
  const {total} = totals(items, data)
  const increasedPointsDelta = data.deals[0]?.increasedPointsBackPercentageDelta
  const totalAmount = increasedPointsDelta
    ? ((total?.originalPrice || 0) * (fullPercentage - (total?.discountPercentage + increasedPointsDelta))) / 100
    : total?.amount

  let cashbackAmount = ((total?.originalPrice || 0) - (totalAmount || 0)) * rate
  const cashbackAmountFPInt = cashbackAmount / 100
  if (cashbackAmountFPInt < 1) {
    cashbackAmount = 0
  } else if (cashbackAmountFPInt < 2) {
    cashbackAmount = Math.round(cashbackAmountFPInt) * 100
  } else {
    cashbackAmount = Math.ceil(cashbackAmountFPInt) * 100
  }

  const cloned = cloneDeep(data)
  cloned.deals.forEach(({productConfig}) => {
    productConfig.products.forEach((p) => {
      if (p?.salePrice?.discount) {
        p.salePrice.discount = 0
      }
    })
  })

  return {
    ...totals(items, cloned),
    cashback: {
      amount: cashbackAmount,
      currency: "TT"
    }
  }
}
